import AbstractElement from "../../pages/AbstractElement";
import * as GSAP from 'gsap';
import TabItem from "./TabItem";
import {ViewEvent} from "../../event/EventStaus";

class TabContent extends AbstractElement {

    private items: any[];
    private currentItem: TabItem;

    constructor(template: JQuery) {
        super(template);
    }


    resize(): void {
        this.resizeContentHeight();
    }

    init(): void {
        this.items = [];
        this.initItems();
    }

    private initItems(): void {
        const items = this.template.find('> .tab__content__item').toArray();
        items.map((element: HTMLElement, index: number) => {
            const tabItem = new TabItem($(element));
            tabItem.emitter.on(ViewEvent.ON_TRANSITION_IN_COMPLETED, this.itemStatusHandler.bind(this));
            tabItem.emitter.on(ViewEvent.ON_TRANSITION_OUT_COMPLETED, this.itemStatusHandler.bind(this));
            this.items.push({target: tabItem});
        });
        this.currentItem = this.items[0].target;
        this.currentItem.transitionIn();
    }

    private itemStatusHandler(data: any): void {
        if (data.type === ViewEvent.ON_TRANSITION_IN_COMPLETED) {
            this.resize();
        }
        if (data.type === ViewEvent.ON_TRANSITION_OUT_COMPLETED) {
            this.currentItem.template.removeClass('active');
            this.currentItem = null;
            this.changeItem(data.id);
        }
    }

    public changeItem(id: number): void {
        if (this.currentItem) {
            this.template.height(this.currentItem.template.outerHeight());
            this.currentItem.transitionOut({id: id});
            return;
        }
        this.currentItem = <TabItem>this.items[id].target;
        GSAP.TweenMax.to(this.template, 0.3, {
            css: {
                height: this.currentItem.template.outerHeight()
            },
            ease: GSAP.Linear.easeOut,
            onComplete: () => {
                this.currentItem.template.addClass("active");
                this.currentItem.transitionIn();
            }
        });
    }

    public changeBgColor(color: string): void {
        if (color === undefined || color === null) color = '#000000';
        this.template.css('background-color', color);
    }

    public resizeContentHeight(): void {
        GSAP.TweenMax.to(this.template, 0.3, {
            css: {
                height: 'auto'
            },
            ease: GSAP.Linear.easeOut
        });
    }
}

export default TabContent;